var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    stroke: "#000",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.095 11.13l-3.377 3.499-.85-.872 3.386-3.519.84.891zM5.21 15.234l.856-.881 3.973 4.081-.443.457c-.109.102-.26.232-.419.232-.072 0-.242-.054-.411-.231l-.004-.004-3.552-3.653z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.948 8.984l.837.889-8.69 8.984c-.109.102-.26.232-.419.232-.072 0-.242-.054-.411-.231l-.004-.004-3.552-3.653.856-.882 3.124 3.218 8.259-8.553z"
  })));
}
export default SvgDoneAll;